import { lazy } from 'react';

export const PlayerWithdrawalsStatusForm = lazy(
  () => import('./PlayerWithdrawalsStatusForm'),
);
